import { SurveillanceParams, SurveillanceResponse } from '../types/surveillance';
import api from '../utils/api';

export const surveillanceApi = {
  /**
   * Get establishment status changes for adherents
   */
  getEstablishmentChanges: async (params: SurveillanceParams = {}): Promise<SurveillanceResponse> => {
    const searchParams: Record<string, string> = {};
    
    if (params.page) searchParams.page = params.page.toString();
    if (params.limit) searchParams.limit = params.limit.toString();
    if (params.fromDate) searchParams.fromDate = params.fromDate;
    if (params.toDate) searchParams.toDate = params.toDate;
    if (params.status && params.status !== 'all') searchParams.status = params.status;
    
    const response = await api.get('/surveillance/establishment-changes', {
      params: searchParams
    });

    return response.data;
  }
}; 